import WorkoutsFooter from './WorkoutsFooter';

export default WorkoutsFooter;
